import Loadable from '@yeutech/react-loadable';

export default Loadable({
  loader: () => import('./ResumePage'),
});
